import { Model, belongsTo, hasMany } from 'miragejs';

export default Model.extend({
  deliveryPerson: belongsTo('employee'),
  property: belongsTo('zone'),
  location: belongsTo('location'),
  slideshows: hasMany('slideshow'),
  welcomeScreenSlides: hasMany('welcome-screen-slide'),
  integrations: hasMany('integration'),
  flows: hasMany('flow'),
});
